<template>
  <div class="container-preferences">
    <v-row class="page-preferences" column fill-height formlittle>
      <v-col class="py-0">
        <v-card
          class="mb-4 flex-grow-1 card card-personalpreference"
          :class="personalpreference?'backgroud-blue': 'backgroud-white'"
        >
          <v-card-title>
            <h1>
              Préférences
              <span class="bis">personnelles</span>
            </h1>
            <v-btn
              class="ml-5 btn-personalpreference secondary2"
              @click="personalpreference = !personalpreference"
            >{{personalpreference ? "Fermer": "Ouvrir"}}</v-btn>
          </v-card-title>
          <v-card-text>
            <p class="subtitle">Définissez les options pour mon compte</p>
            <v-slide-y-transition>
              <div v-if="personalpreference" class="personal-preference">
                <v-row>
                  <v-col cols="4" class="formlittle">
                    <h3>Options générales</h3>
                    <v-checkbox
                      color="#5589e0"
                      :name="$Utils.randomstring('helpBubble')"
                      label="Afficher les bulles d'aide"
                      v-model="personalPreferenceData.helpBubble"
                    ></v-checkbox>
                    <v-checkbox
                      color="#5589e0"
                      :name="$Utils.randomstring('dailyMail')"
                      label="Recevoir les mails quotidien"
                      v-model="personalPreferenceData.dailyMail"
                    ></v-checkbox>
                    <m-form-text
                      type="number"
                      label="Définir le début de la journée à X heures : "
                      :name="$Utils.randomstring('startDay')"
                      v-model="personalPreferenceData.startDay"
                      placeholder="heures"
                      label-position="top"
                    ></m-form-text>
                  </v-col>
                  <v-col class="formlittle">
                    <h3>Options Calendrier</h3>
                    <v-button type="button" @click="authazur">Authorisation Azur</v-button>
                    <v-checkbox
                      :name="$Utils.randomstring('showOtherCalendar')"
                      color="#5589e0"
                      label="Par default, voir les calendriers des autres utilisateurs plutôt que le sien"
                      v-model="personalPreferenceData.showOtherCalendar"
                    ></v-checkbox>
                    <v-checkbox
                      :name="$Utils.randomstring('showWeekend')"
                      color="#5589e0"
                      label="Afficher les samedis et les dimanches"
                      v-model="personalPreferenceData.showWeekend"
                    ></v-checkbox>
                    <v-checkbox
                      :name="$Utils.randomstring('confirmMoveEvent')"
                      color="#5589e0"
                      label="Confirmer le déplacement d'un événement"
                      v-model="personalPreferenceData.confirmMoveEvent"
                    ></v-checkbox>
                    <swatches-picker v-model="personalPreferenceData.color" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn
                      class="btn-personalpreference primary2"
                      @click="savePersonalPreference"
                    >Enregistrer</v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-slide-y-transition>
          </v-card-text>
        </v-card>
        <v-card
          class="mb-4 flex-grow-1 card card-sharedpreference"
          :class="sharedpreference?'backgroud-brown': 'backgroud-white'"
        >
          <v-card-title class="d-flex flex-row container-title-shared">
            <div class="d-flex flex-column">
              <div class="d-flex flex-row">
                <h1>
                  Préférences
                  <span class="bis">partagées</span>
                </h1>
                <v-btn
                  class="ml-5 btn-sharedpreference secondary2"
                  @click="sharedpreference =!sharedpreference"
                >{{sharedpreference ? "Fermer":"Ouvrir"}}</v-btn>
              </div>
              <p class="subtitle">Définissez les options pour tous les utilisateurs</p>
            </div>
            <div class="container-logo" v-if="logoUrl || sharedPreferenceData.societyLogo">
              <div
                class="logo"
                :style="{ backgroundImage: `url(${logoUrl?logoUrl:sharedPreferenceData.societyLogo})` }"
              ></div>
            </div>
          </v-card-title>
          <v-card-text>
            <v-slide-y-transition>
              <div v-if="sharedpreference" class="shared-preference">
                <v-row>
                  <v-col cols="2">
                    <h3>Nom de la société :</h3>
                  </v-col>
                  <v-col cols="4">
                    <m-form-text v-model="sharedPreferenceData.societyName"></m-form-text>
                  </v-col>
                  <v-col cols="6">
                    <v-file-input
                      class="my-3"
                      hide-details
                      label="Logo de la société"
                      accept="file/*"
                      v-model="logo"
                      @change="onLogoChange"
                    ></v-file-input>
                  </v-col>
                </v-row>
                <hr />
                <v-row>
                  <v-col cols="3" class="formlittle">
                    <h3>Autres options</h3>
                    <v-checkbox
                      color="#757575"
                      label="envoyer un mail à l'agent si le calendier n'est pas rempli"
                      v-model="sharedPreferenceData.mailIfEmptyCalendar"
                    ></v-checkbox>
                    <v-checkbox
                      color="#757575"
                      label="Utiliser la base immeuble"
                      v-model="sharedPreferenceData.useRealestate"
                    ></v-checkbox>
                    <v-checkbox
                      color="#757575"
                      label="Utiliser les diagnostiques"
                      v-model="sharedPreferenceData.useDiagnostic"
                    ></v-checkbox>
                    <v-checkbox
                      color="#757575"
                      label="Utiliser les LAB"
                      v-model="sharedPreferenceData.useLab"
                    ></v-checkbox>
                    <m-form-text
                      label="FTP realestate"
                      v-model="sharedPreferenceData.ftpRealestate"
                      placeholder
                      label-position="top"
                    ></m-form-text>
                    <m-form-text
                      label="Prochaine référence bien"
                      v-model="sharedPreferenceData.nextRefOffers"
                      placeholder
                      label-position="top"
                    ></m-form-text>
                    <m-form-text
                      label="jours fériés"
                      v-model="sharedPreferenceData.holidays"
                      label-position="top"
                    ></m-form-text>
                    <m-form-text
                      label="Ma fiche société"
                      v-model="sharedPreferenceData.mySociety"
                      label-position="top"
                    ></m-form-text>
                  </v-col>
                  <v-col cols="3" class="formlittle">
                    <h3>Les langues</h3>
                    <v-row>
                      <v-col class="pt-0">
                        <v-checkbox
                          color="#757575"
                          label="Français"
                          v-model="sharedPreferenceData.french"
                        ></v-checkbox>
                        <v-checkbox
                          color="#757575"
                          label="Anglais"
                          v-model="sharedPreferenceData.english"
                        ></v-checkbox>
                        <v-checkbox
                          color="#757575"
                          label="Italien"
                          v-model="sharedPreferenceData.italian"
                        ></v-checkbox>
                      </v-col>
                      <v-col class="pt-0">
                        <v-checkbox
                          color="#757575"
                          label="Russe"
                          v-model="sharedPreferenceData.russian"
                        ></v-checkbox>
                        <v-checkbox
                          color="#757575"
                          label="Allemand"
                          v-model="sharedPreferenceData.german"
                        ></v-checkbox>
                        <v-checkbox
                          color="#757575"
                          label="Espagnol"
                          v-model="sharedPreferenceData.spanish"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <h3 class="mt-4">Les suivis</h3>
                    <m-form-text
                      type="number"
                      v-model="sharedPreferenceData.nbMaxSuiviContact"
                      label="Nombre maximum d'agents pouvant suivre un contact (0=>illimité)"
                      label-position="top"
                    ></m-form-text>
                    <m-form-text
                      type="number"
                      v-model="sharedPreferenceData.nbMaxSuiviOffer"
                      label="Nombre maximum d'agents pouvant suivre une offre (0=>illimité)"
                      label-position="top"
                    ></m-form-text>
                  </v-col>
                  <v-col cols="3" class="formlittle">
                    <h3 class="mt-5">Prefixe pour les références des offres</h3>
                    <m-form-text
                      label="model de référence"
                      v-model="sharedPreferenceData.modelRefOffer"
                      label-position="top"
                    ></m-form-text>
                    <small>ex : mP-%_happy (le % représente le nombre de la référence)</small>
                    <m-form-text
                      type="number"
                      label="nombre de chiffre"
                      v-model="sharedPreferenceData.nbChiffreRefOffer"
                      label-position="top"
                    ></m-form-text>
                  </v-col>
                  <v-col cols="3" class="formlittle">
                    <h3>Les quartiers</h3>
                    <table class="tablestriped backgroud-white tab-district">
                      <tbody>
                        <tr v-for="(district, indexDistricts) in districts" :key="indexDistricts">
                          <td d-flex flex-row>
                            <span>{{district.text}}</span>
                            <span @click="districts.splice(indexDistricts, 1)">
                              <icon class="icon-delete withpointer" name="home"></icon>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <v-row>
                      <v-col cols="10" class="pr-0">
                        <m-form-text
                          v-model="newDistrictName"
                          label="Ajouter un quartier"
                          label-position="top"
                        ></m-form-text>
                      </v-col>
                      <v-col class="mt-5" @click="addDistrict()">
                        <icon class="icon-add withpointer" name="home"></icon>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class>
                    <h3>Modèle de mail</h3>
                    <m-form-select
                      label="Langue"
                      :label-width="3"
                      :items="$store.state.items_languages"
                      v-model="selectedLanguage"
                    ></m-form-select>
                    <m-form-text
                      type="textarea"
                      v-model="modelesMail[selectedLanguage]"
                      :label-width="3"
                      :label="'Modèle en ' + selectedLanguage"
                      :name="$Utils.randomstring('modelmail')"
                    ></m-form-text>
                    <v-row>
                      <v-col cols="9" offset="3">
                        <small>Vous devez écrire "VAR_NOM" à l'endroit où vous voulez faire apparaître le nom du contact et "VAR_OFFRE" à l'endroit où vous voulez faire apparapitre la ou les offres</small>
                        <!-- <v-btn
                          small
                          v-if="selectedLanguage"
                          class="btn-sharedpreference"
                          @click="addModelMailLangue"
                        >Ajouter le modèle de mail pour la langue : {{selectedLanguage}}</v-btn>-->
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn
                      class="btn-sharedpreference primary2"
                      @click="savesharedPreference"
                    >Enregistrer</v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-slide-y-transition>
          </v-card-text>
        </v-card>

        <v-card
          class="flex-grow-1 card card-rightpreference mb-4"
          :class="rightpreference?'backgroud-gray': 'backgroud-white'"
        >
          <v-card-title>
            <h1>
              <span class="bis">Droits</span> des utilisateurs
            </h1>
            <v-btn
              class="ml-5 btn-rightpreference secondary2"
              @click="rightpreference = !rightpreference"
            >{{rightpreference?"Fermer":"Ouvrir"}}</v-btn>
          </v-card-title>
          <v-card-text>
            <p class="subtitle">
              Définissez les droits d'accès pour chaque type d'utilisateur
              <br />Vous pouvez cliquer sur l'intitulé d'une ligne ou d'une colonne pour sélectionner toute la ligne ou toute la colonne.
            </p>
            <v-slide-y-transition>
              <div v-if="rightpreference" class="right-preference">
                <v-row>
                  <v-col>
                    <table class="tablestriped blackheader backgroud-white">
                      <thead>
                        <tr>
                          <th>Droits</th>
                          <th
                            class="item-header"
                            v-for="(item, index) in itemsType"
                            :key="index"
                            @click="checkCol(index)"
                          >
                            <strong>{{item.text}}</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(itemRow, indexRow) in rightPreferenceData" :key="indexRow">
                          <td class="bis" @click="checkLine(itemRow)">{{itemRow.text}}</td>
                          <td
                            v-for="(itemCol, indexCol) in itemsType"
                            :class="{ 'item-header':true, 'text-center':(indexCol>0), 'font-weight-bold':(indexCol==0) }"
                            :key="indexCol"
                          >
                            <v-simple-checkbox v-model="itemRow[itemCol.value]"></v-simple-checkbox>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn
                      class="btn-rightpreference primary2"
                      @click="saveRightPreference"
                    >Enregistrer</v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-slide-y-transition>
          </v-card-text>
        </v-card>

        <v-card
          class="flex-grow-1 card card-buildingpreference mb-4"
          :class="buildingpreference?'backgroud-gray': 'backgroud-white'"
        >
          <v-card-title>
            <h1>
              Les
              <span class="bis">immeubles</span>
            </h1>
            <v-btn
              class="ml-5 btn-buildingpreference secondary2"
              @click="buildingpreference = !buildingpreference"
            >{{buildingpreference?"Fermer":"Ouvrir"}}</v-btn>
          </v-card-title>
          <v-card-text>
            <p class="subtitle">Voir la liste des immeubles.</p>
            <v-slide-y-transition>
              <div v-if="buildingpreference" class="right-preference">
                <v-row>
                  <v-col>
                    <table class="tablestriped blackheader backgroud-white">
                      <thead>
                        <tr>
                          <th>Nom de l'immeuble</th>
                          <th>ID XML</th>
                          <th>Adresse</th>
                          <th>CP</th>
                          <th>Ville</th>
                          <th>Biens liés</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row_bu, indexBuilding) in buildings" :key="indexBuilding">
                          <td>{{row_bu.bu_name}}</td>
                          <td>{{row_bu.bu_id_xml}}</td>
                          <td>
                            {{row_bu.bu_address1}}
                            <br />
                            {{row_bu.bu_address2}}
                          </td>
                          <td>{{row_bu.bu_zip}}</td>
                          <td>{{row_bu.bu_city}}</td>
                          <td>
                            <ul v-if="row_bu.offers.length">
                              <li
                                v-for="row_of in row_bu.offers"
                                :key="indexBuilding+'-'+row_of.of_id"
                              >
                                <a
                                  @click="$router.push('/offers/'+row_of.of_id+'/edit')"
                                >{{row_of | formatOfferName}}</a>
                              </li>
                            </ul>
                            <div v-else>
                              <a @click="deleteBuilding(row_bu)">Effacer</a>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </v-col>
                </v-row>
              </div>
            </v-slide-y-transition>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- <m-message-dialog
      v-model="modalMessageSaveData"
      text="Vos modifications ont bien été prises en compte"
      styleModal="ok"
      @closeModal="closeModalMessage()"
    ></m-message-dialog>-->
    <v-snackbar v-model="modalMessageSaveData" top :timeout="3000">
      Vos modifications ont bien été prises en compte
      <v-btn color="green" text @click="modalMessageSaveData = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
// import Vue from "vue";
import { Swatches } from "vue-color";

export default {
  name: "preferences",
  components: { "swatches-picker": Swatches },
  data() {
    return {
      user: null,
      // affichage des parties
      personalpreference: false,
      sharedpreference: false,
      rightpreference: false,
      buildingpreference: false,
      // data preferences
      personalPreferenceData: {},
      sharedPreferenceData: {},
      selectedLanguage: "fr",
      modelesMail: {},
      modeleMailtext: "",
      itemsPages: [],
      itemsType: [],
      rightPreferenceData: [],
      buildings: [],
      districts: [],
      newDistrictName: "",
      modalMessageSaveData: false,
      logoUrl: null,
      logo: null
    };
  },
  watch: {
    buildingpreference(v) {
      if (v) this.loadBuildings();
    }
  },

  async mounted() {
    this.user = await this.$store.getters.get_user;
    this.personalPreferenceData = this.$store.state.preferences.personal;
    if (!this.personalPreferenceData) this.personalPreferenceData = {};
    if (!this.personalPreferenceData.color)
      this.personalPreferenceData.color = {};
    this.districts = this.$store.state.preferences.shared.districts;
    if (!this.districts) this.districts = [];
    // console.log(
    //   "this.$store.state.preferences.shared",
    //   this.$store.state.preferences.shared
    // );
    this.logoUrl = this.$store.state.preferences.shared.logoUrl;
    this.sharedPreferenceData = this.$store.state.preferences.shared;
    this.modelesMail = this.$store.state.preferences.shared.modelesMail;
    if (!this.modelesMail) this.modelesMail = {};
    this.itemsType = this.$store.state.items_co_type.filter(item => {
      return item.value;
    });
    this.itemsPages = this.$store.state.items_page_right;
    this.rightPreferenceData = await this.loadRight();
  },
  methods: {
    async authazur() {
      window.open(
        this.$config.server_url + "/authorizeazure/" + this.$store.state.token,
        "_self"
      );
    },
    onLogoChange(f) {
      if (f.name.match(/\.(jpg|jpeg|png|gif)$/)) {
        this.logo = f;
        var reader = new FileReader();
        var me = this;
        reader.onload = (function() {
          return function(e) {
            me.logoUrl = e.target.result;
          };
        })(f);
        reader.readAsDataURL(f);
      }
    },
    async deleteBuilding(row_bu) {
      if (window.confirm(`Confirmer effacement de l'immeuble ?`)) {
        let params = {};
        await this.$axios.delete(
          this.$config.server_url + "/api/1.0/buildings/" + row_bu.bu_id,
          { params }
        );
        await this.loadBuildings();
      }
    },
    async loadBuildings() {
      let params = { addoffers: true, sort: "bu_name" };
      let response = await this.$axios.get(
        this.$config.server_url + "/api/1.0/buildings",
        { params }
      );
      this.buildings = response.data.data;
    },
    // addModelMailLangue() {
    //   if (!this.modeleMailtext) return;
    //   let newmodelMail = {
    //     value: this.selectedLanguage,
    //     text: this.modeleMailtext
    //   };
    //   this.modelesMail.push(newmodelMail);
    //   // console.log("this.modelesMail", this.modelesMail);
    // },
    showModalMessage() {
      this.modalMessageSaveData = true;
    },
    closeModalMessage() {
      this.modalMessageSaveData = false;
    },
    addDistrict() {
      if (!this.newDistrictName) return;
      let newDistrict = {
        value: this.newDistrictName,
        text: this.newDistrictName
      };
      this.districts.push(newDistrict);
      this.newDistrictName = "";
    },
    checkCol(col) {
      let ok = this.rightPreferenceData[0][this.itemsType[col].value];
      for (
        let iDataRi = 0;
        iDataRi < this.rightPreferenceData.length;
        iDataRi++
      ) {
        const row = this.rightPreferenceData[iDataRi];
        for (let j = 0; j < this.itemsType.length; j++) {
          const type = this.itemsType[j];
          if (col == j) {
            row[type.value] = !ok;
          }
        }
      }
      // force un update... sinon problème (je ne sais pas pourquoi)
      this.$forceUpdate();
    },
    checkLine(line) {
      for (
        let iDataRi = 0;
        iDataRi < this.rightPreferenceData.length;
        iDataRi++
      ) {
        const row = this.rightPreferenceData[iDataRi];
        if (line.value === row.value) {
          let ok = row[this.itemsType[0].value];
          for (let j = 0; j < this.itemsType.length; j++) {
            const type = this.itemsType[j];
            row[type.value] = !ok;
          }
        }
      }
    },
    async savePersonalPreference() {
      this.user.co_preferences = this.personalPreferenceData;
      await this.$axios.put(
        this.$config.server_url + "/api/1.0/contacts/" + this.user.co_id,
        { co_preferences: this.personalPreferenceData }
      );
      this.$store.commit("set_preferences", {
        preference: "personal",
        data: this.personalPreferenceData
      });
      this.showModalMessage();
    },
    async loadRight() {
      let response = await this.$axios.get(
        this.$config.server_url + "/api/1.0/rights"
      );
      let data = [];
      for (let ipage = 0; ipage < this.itemsPages.length; ipage++) {
        const page = this.itemsPages[ipage];
        let itemsData = {};
        itemsData.text = page.text;
        itemsData.value = page.value;
        let tab_right_page = response.data.data.filter(element => {
          return element.ri_right === page.value;
        });
        for (let index = 0; index < tab_right_page.length; index++) {
          const row_ri = tab_right_page[index];
          itemsData[row_ri.ri_type] = row_ri.ri_value;
        }
        data.push(itemsData);
      }
      return data;
    },
    async savesharedPreference() {
      this.sharedPreferenceData.districts = this.districts;
      this.sharedPreferenceData.modelesMail = this.modelesMail;
      this.sharedPreferenceData.logoUrl = this.logoUrl;
      // console.log("this.modelesMail", this.modelesMail);
      // console.log("sharedPreferenceData", this.sharedPreferenceData);
      await this.$axios.post(
        this.$config.server_url + "/api/1.0/rights/sharedpreference",
        this.sharedPreferenceData
      );
      this.showModalMessage();
    },
    async saveRightPreference() {
      let rows_ri = [];
      for (let i = 0; i < this.rightPreferenceData.length; i++) {
        const page = this.rightPreferenceData[i];
        for (let j = 0; j < this.itemsType.length; j++) {
          const type = this.itemsType[j];
          if (!page[type.value]) {
            page[type.value] = false;
          }
          rows_ri.push({
            ri_right: page.value,
            ri_value: page[type.value],
            ri_type: type.value
          });
        }
      }
      await this.$axios.post(
        this.$config.server_url + "/api/1.0/rights/",
        rows_ri
      );
      this.showModalMessage();
    }
  }
};
</script>
<style lang="scss" scoped>
.container-preferences {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.card {
  padding: 20px;
}
h1 {
  width: 335px;
}
.backgroud-blue {
  background-color: #bde0f0;
}
.backgroud-brown {
  background-color: #d3c8ba;
}
.backgroud-gray {
  background-color: #dcd8d2;
}
.backgroud-white {
  background-color: #fff;
}
// .theme--light.v-btn {
//   color: black;
// }

.subtitle {
  font-size: 15px;
}
.tab-district {
  .icon-delete {
    float: right;
  }
}
.icon-add {
  margin-top: 10px;
  margin-left: 10px;
}
.tiret-ref {
  padding: 10px;
  margin-top: 18px;
}
.container-title-shared {
  justify-content: space-between;
}
#inspire
  .v-input.theme--light.v-text-field.v-text-field--is-booted.v-file-input {
  margin: 0 !important;
  padding: 0 !important;
}
.container-logo {
  float: right;
}
.logo {
  width: 162px;
  height: 99px;
  background-size: contain;
  background-position: center;
}
</style>
